__turbopack_context__.v({
  "animated-download-svg": "lnEDnW_animated-download-svg",
  "arrow-pulse": "lnEDnW_arrow-pulse",
});
